import { CONSIDERATION_CHECKLIST, ENGINEERING_CONSIDERATIONS } from '../data/engineeringConsiderations';
import { TIER_LABELS } from '../data/references';

interface Props {
  checked: string[];
  onToggle: (id: string) => void;
}

export function ConsiderationsPanel({ checked, onToggle }: Props) {
  return (
    <div className="considerations">
      <p className="explorer-lede">
        Questions, not conclusions. Nothing in this section produces a pass, a fail, a compliance determination, or a
        suitability finding — the tool has no basis on which to make one.
      </p>

      <ul className="consideration-list">
        {ENGINEERING_CONSIDERATIONS.map((item) => (
          <li key={item.id} className="consideration">
            <p className="consideration-category">{item.category}</p>
            <p className="consideration-question">{item.question}</p>
            <p className="consideration-context">{item.context}</p>
            <p className="consideration-basis">
              <span className="tier-tag">{TIER_LABELS[item.basisTier]}</span>
              {item.basis}
            </p>
          </li>
        ))}
      </ul>

      <div className="checklist">
        <div className="panel-head-row">
          <h3 className="panel-title">Considerations reviewed</h3>
          <span className="checklist-count">
            {checked.length} of {CONSIDERATION_CHECKLIST.length}
          </span>
        </div>
        <p className="field-help">
          A record of what you have reviewed, for your own documentation. Ticking every box does not approve anything —
          it says only that you looked.
        </p>
        <ul className="checklist-items">
          {CONSIDERATION_CHECKLIST.map((item) => (
            <li key={item.id}>
              <label>
                <input type="checkbox" checked={checked.includes(item.id)} onChange={() => onToggle(item.id)} />
                <span>{item.label}</span>
              </label>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
